module.exports = __webpack_public_path__ + "assets/b82d47d9e6654e772b3666f1d1f91cce.mp3";